/**
 * Given a text string and font size, returns the pixel width of the text.
 * Copied from https://stackoverflow.com/a/4032497/1228411
 */
export default function measureText(text, styles) {
  var lDiv = document.createElement('div');

  document.body.appendChild(lDiv);

  lDiv.style.fontFamily = styles.fontFamily;
  lDiv.style.fontSize = styles.fontSize;
  lDiv.style.fontWeight = styles.fontWeight;
  lDiv.style.position = 'absolute';
  lDiv.style.left = -1000;
  lDiv.style.top = -1000;

  lDiv.innerHTML = text;

  var lResult = {
      width: lDiv.clientWidth,
      height: lDiv.clientHeight
  };

  document.body.removeChild(lDiv);
  lDiv = null;

  return lResult;
}
